import { get, post, put } from '@elementary/common-ui/utils/http';
import {
  CreateCodeProjectRequest,
  UpdateCodeProjectRequest,
  FetchCodeProjectsResponse,
  TestGitAccessTokenApi,
} from '../types';

export const fetchCodeProjects = (
  envId: string,
): Promise<FetchCodeProjectsResponse> =>
  get(
    `${import.meta.env.VITE_API_BASE_URL}/environments/${envId}/code-projects`,
  );

export const setCodeProject = (envId: string, data: CreateCodeProjectRequest) =>
  post(
    `${import.meta.env.VITE_API_BASE_URL}/environments/${envId}/code-projects`,
    data,
  );

export const updateCodeProject = (
  envId: string,
  data: UpdateCodeProjectRequest,
) =>
  put(
    `${import.meta.env.VITE_API_BASE_URL}/environments/${envId}/code-projects`,
    data,
  );

export const testGitAccessToken = (
  envId: string,
  data: TestGitAccessTokenApi,
) =>
  post(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/code-projects/test-token`,
    data,
  );
